import {
  ExternalTransaction,
  ExternalTransactionAvailableActions,
} from '../models'

/**
 * Check if the available actions of a given external transaction includes a specific action.
 */
export function checkExtTxIncludesAvailableAction(
  transaction: ExternalTransaction,
  action: ExternalTransactionAvailableActions,
): boolean {
  const availableActions = transaction.availableActions
  return (
    availableActions !== undefined &&
    availableActions.length !== 0 &&
    availableActions.includes(action)
  )
}

/**
 * Check that for a list of a transactions, the available actions for some of the transactions includes a specific action.
 */
export function checkSomeExtTxIncludesAvailableAction(
  transactions: ExternalTransaction[],
  action: ExternalTransactionAvailableActions,
): boolean {
  return (
    transactions.length !== 0 &&
    transactions.some(t => checkExtTxIncludesAvailableAction(t, action))
  )
}

/**
 * Check that for a list of a transactions, the available actions for some of the transactions includes a specific action.
 */
export function checkEveryExtTxIncludesAvailableAction(
  transactions: ExternalTransaction[],
  action: ExternalTransactionAvailableActions,
): boolean {
  return (
    transactions.length !== 0 &&
    transactions.every(t => checkExtTxIncludesAvailableAction(t, action))
  )
}
